import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlEncode',
})
export class urlEnDecodePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value && typeof value == 'string') {
      if (args[0] === true) {
        return encodeURIComponent(value);
      } else {
        return decodeURIComponent(value);
      }
    }
    return value;
  }
}
